module.exports = __webpack_public_path__ + "img/logo-xuetang.2e034ba0.png";